import { createServerFn } from "@tanstack/react-start";
import { getRequest, setResponseHeader } from "@tanstack/react-start/server";
import { getSessionFromRequest, destroySession } from "@/lib/session";

export interface AuthUser {
  userId: string;
  email: string;
  name: string;
}

// Session validity is determined by the HMAC-signed cookie's Max-Age (7 days),
// not by the Google ID token's expiration (~1 hour). We intentionally do NOT
// check token.exp here — doing so would log users out every hour despite
// having a valid session. The token is still stored in the session for gRPC
// calls, but its expiry should not invalidate the authenticated session.
export const getAuthUser = createServerFn({ method: "GET" }).handler(
  async (): Promise<AuthUser | null> => {
    const request = getRequest();
    const session = await getSessionFromRequest(request);

    if (!session.userId) {
      return null;
    }

    return {
      userId: session.userId,
      email: session.email || "",
      name: session.name || "",
    };
  },
);

export const logoutFn = createServerFn({ method: "POST" }).handler(async () => {
  const cookie = await destroySession();
  setResponseHeader("Set-Cookie", cookie);
});
